import React, { useState, useEffect, useContext } from 'react';
import Modal from "react-bootstrap/Modal";
import { AwsFileUrl, BASE_URL_STATIC, Image_Base_Url } from '../../../../../config';
import Slider from 'react-slick';
import { ApiContext } from '../../../UseContext/ApiCall';
import ProfilePostThreeDotPopup from './ThreeDot/ProfilePostThreeDotPopup';
import ProfilePostCommentThreeDotPopup from './CommentThreeDot/ProfilePostCommentThreeDotPopup';
import AddComments from '../../../Button/AddComments';
import { GoogleMap, Marker } from "@react-google-maps/api";
import Userpopup from '../../Userpopup';
// import ReactPlayer from 'react-player';
// import VideoTag from "../../../../Common/assets/videoTag";
// import ImageTag from "../../../../Common/assets/imageTag";
// import FavouritePostButton from '../../../Button/FavouriteButton/FavouritePostButton';
// import LikeButton from '../../../Button/LikeButton/LikeButton';
// import ViewPostButton from '../../../Button/ViewButton/ViewPostButton';


const ProfilePostPopup = ({ postId, showPostsPopup, setShowPostsPopup, postsPopupData, setPostsPopupData, handlePostShare }) => {

  const [showProfilePostThreeDotPopup, setShowProfilePostThreeDotPopup] = useState(false);
  const [showProfilePostCommentThreeDotPopup, setShowProfilePostCommentThreeDotPopup] = useState(false);

  const { 
    getPostComment, comments, setComments, parentSpinner, setParentSpinner, loggedInUserId, handleFollowUnfollow, 
    
    showHomeTagsOnPhoto, setShowHomeTagsOnPhoto,
    setShowHomeVideoTagPopup,
    setHomeVideoAddedTags,
    setShowHomeGridPopup,
    setHomeGridPost,
  } = useContext(ApiContext);


  //------------------- comment states-----------------
  //const [postId, setPostId] = useState('') // memeID , bestClipId , reelId

  const [clickedreply, setClickedReply] = useState(false)
  const [viewReply, setViewReply] = useState(false)
  const [comment, setComment] = useState();
  const [showPopup, setShowPopup] = useState(false);

  // const [activeIndex, setActiveIndex] = useState(0);
  // const sliderRef = useRef(null);

  // To add post to favourite
  // const settings = {
  //   dots: true,
  //   className: "profilePostsPopup-post-slider",
  //   infinite: false,
  //   // centerPadding: "60px",
  //   slidesToShow: 1,
  //   swipeToSlide: true,
  //   afterChange: (index) => setActiveIndex(index),
  // };

  // handle click three dot
  const handleClickThreeDot = (post) => {
    if (loggedInUserId !== post.postedBy) {
      setShowProfilePostThreeDotPopup(true);
    } else{
      setShowPopup(true)
    };
  };

  // handle click video tag icon
  const handleClickVideoTagIcon = (tags) => {
    setShowHomeVideoTagPopup(true);

    setHomeVideoAddedTags(tags);
  };

  const [seeMoreLess, setSeeMoreLess] = useState({});
  
  // handle see more less
  const handleSeeMoreLess = (_id) => {
    setSeeMoreLess((prev) => ({
      ...prev,
      [_id]: !prev[_id],
    }));
  };

  // handle click photo/video grid post
  const handleClickGridPost  = (gridPost) => {
    setShowHomeGridPopup(true);
    
    setHomeGridPost(gridPost);
  };

  // handle click photo tag icon
  const handleClickPhotoTagIcon = (postId) => {
    setShowHomeTagsOnPhoto(prev => ({
      ...prev,
      [postId]: !prev[postId]
    }));
  };

  // photo/video slider setting
  const photoVideoSetting = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    infinite: false,
    dots: true,
  }; 

  useEffect(() => {
  setClickedReply(false)
  setViewReply(false)
  // getPostComment(postId, config)
  }, [postsPopupData]);

  console.log('postsPopupData : ', postsPopupData);




  return (
    <>
      {/* Popup */}
      <>
        {/* Profile Photos And Videos Three Dot Popup */}
        <ProfilePostThreeDotPopup showProfilePostThreeDotPopup={showProfilePostThreeDotPopup} setShowProfilePostThreeDotPopup={setShowProfilePostThreeDotPopup} setShowPostsPopup={setShowPostsPopup} postsPopupData={postsPopupData} setPostsPopupData={setPostsPopupData} />

        {postsPopupData && <Userpopup showPopup={showPopup} setShowPopup={setShowPopup} postsPopupData={postsPopupData} /> }

        {/* Profile Photos And Videos Comment Three Dot Popup */}
        <ProfilePostCommentThreeDotPopup showProfilePostCommentThreeDotPopup={showProfilePostCommentThreeDotPopup} setShowProfilePostCommentThreeDotPopup={setShowProfilePostCommentThreeDotPopup} comment={comment} />
        
        <ProfilePostCommentThreeDotPopup showProfilePostCommentThreeDotPopup={showProfilePostCommentThreeDotPopup} setShowProfilePostCommentThreeDotPopup={setShowProfilePostCommentThreeDotPopup} comment={comment} getPostComment={getPostComment} />
      </>


      {/* Profile Photos And Videos Popup */}
      <Modal show={showPostsPopup} onHide={() => setShowPostsPopup(false)} size="xl" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false} className="create-call" >
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          {
            postsPopupData
            &&
            <section className="d-flex" style={{ height: '75vh' }}>
              {/* Left > PhotoVideo */}
              <div className="w-50 bg-secondary d-flex align-items-center justify-content-center rounded-4">
                {/* Check in/Location image */}
                <>
                  {
                    (postsPopupData.postType === 'location' && postsPopupData.location && postsPopupData.location.placeImage) 
                    &&
                    <div className='my-4 flex-grow-1'>
                      <GoogleMap
                        center={{ lat: postsPopupData.location.lat, lng: postsPopupData.location.lng }}
                        mapContainerStyle={{ height: "250px", width: "100%" }}
                        zoom={15}
                        options={{ 
                          mapTypeId: "satellite",
                          fullscreenControl: true, 
                        }}
                      >
                        <Marker position={{ lat: postsPopupData.location.lat, lng: postsPopupData.location.lng }} />
                      </GoogleMap>
                    </div>
                  }
                </>

                {/* Music Image */}
                <>
                  {
                    (postsPopupData.postType === 'music' && postsPopupData.music && postsPopupData.music.musicImage === true)
                    &&
                    <div className='my-3 text-center border bg-light flex-grow-1'>
                      <img src={postsPopupData.music.image} alt='musicImage' />
                    </div>
                  }
                </>

                {/* Camera/Photo/Video > Carousel */}
                <>
                  {
                    (postsPopupData.carouselGrid === 'carousel' && postsPopupData.photoVideo && postsPopupData.photoVideo.length > 0)
                    &&
                    <Slider className='home-photoVideo-slider border my-3 flex-grow-1' {...photoVideoSetting}>              
                      {
                        postsPopupData.photoVideo.map((photoVideoValue, photoVideoIndex) => (
                          <div className='text-center position-relative' key={photoVideoIndex}>
                            {
                              photoVideoValue.fileUrl.includes('mp4')
                              ?
                              // Video
                              <>
                                <video src={AwsFileUrl+photoVideoValue.fileUrl} />

                                {/* tag Icon */}
                                <>
                                  {
                                    (photoVideoValue.tags.length > 0)
                                    &&
                                    <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer' onClick={() => handleClickVideoTagIcon(photoVideoValue.tags)}>
                                      <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                                    </div>
                                  }
                                </>
                              </>
                              :
                              // Photo
                              <>
                                <img 
                                  src={photoVideoValue.fileUrl.includes('gif') ? photoVideoValue.fileUrl : AwsFileUrl+photoVideoValue.fileUrl} 
                                  className={`${postsPopupData.postType === 'collage' ? 'border border-dark' : ''} object-fit-contain`} alt="photoVideo" 
                                />

                                {/* Tags */}
                                <>
                                  {
                                    (showHomeTagsOnPhoto[postsPopupData._id] && photoVideoValue.tags.length > 0)
                                    &&
                                    photoVideoValue.tags.map((tagValue, tagIndex) => (
                                      <div className='position-absolute pt-1 px-2 bg-secondary rounded-2 d-flex align-items-center gap-2 text-white' key={tagIndex}
                                        style={{ 
                                          top: `${tagValue.offsetY}%`, 
                                          left: `${tagValue.offsetX}%`, 
                                          zIndex: `${tagIndex}`,
                                          fontSize: '13px',
                                          transform: 'translate(-50%, -0%)'
                                        }} 
                                      >
                                        <span>{tagValue.userName}</span>
                                        {/* <span className='cursor-pointer'>✖</span> */}
                                      </div>
                                    ))
                                  }
                                </>

                                {/* tag Icon */}
                                <>
                                  {
                                    (photoVideoValue.tags.length > 0)
                                    &&
                                    <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer' onClick={() => handleClickPhotoTagIcon(postsPopupData._id)}>
                                      <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                                    </div>
                                  }
                                </>
                              </>
                            }
                          </div>
                        ))
                      }
                    </Slider>
                  }
                </>

                {/* Camera/Photo/Video > Grid (2) */}
                <>
                  {
                    (postsPopupData.carouselGrid === 'grid' && postsPopupData.photoVideo && postsPopupData.photoVideo.length === 2)
                    &&
                    <div className='border my-3 bg-light d-flex align-items-center justify-content-center flex-grow-1' style={{ height: '40vh' }} onClick={() => handleClickGridPost(postsPopupData)} >
                      <div style={{ height: '40vh' }}>
                        {
                          (postsPopupData.photoVideo[0].fileUrl.includes('mp4'))
                          ?
                          <video src={AwsFileUrl+postsPopupData.photoVideo[0].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '40vh', width: '25vw' }} ></video>
                          :
                          <img src={AwsFileUrl+postsPopupData.photoVideo[0].fileUrl} className='border object-fit-cover' style={{ height: '40vh', width: '25vw' }} alt="photoVideo" />
                        }
                      </div>

                      <div style={{ height: '40vh' }}>
                        {
                          (postsPopupData.photoVideo[1].fileUrl.includes('mp4'))
                          ?
                          <video src={AwsFileUrl+postsPopupData.photoVideo[1].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '40vh', width: '25vw' }} ></video>
                          :
                          <img src={AwsFileUrl+postsPopupData.photoVideo[1].fileUrl} className='border object-fit-cover' style={{ height: '40vh', width: '25vw' }} alt="photoVideo" />
                        }
                      </div>
                    </div>
                  }
                </>

                {/* Camera/Photo/Video > Grid (3) */}
                <>
                  {
                    (postsPopupData.carouselGrid === 'grid' && postsPopupData.photoVideo && postsPopupData.photoVideo.length === 3)
                    &&
                    <div className='border my-3 bg-light d-flex align-items-center justify-content-center flex-grow-1' style={{ height: '40vh' }} onClick={() => handleClickGridPost(postsPopupData)} >
                      <div style={{ height: '40vh' }}>
                        {
                          (postsPopupData.photoVideo[0].fileUrl.includes('mp4'))
                          ?
                          <video src={AwsFileUrl+postsPopupData.photoVideo[0].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '40vh', width: '25vw' }} ></video>
                          :
                          <img src={AwsFileUrl+postsPopupData.photoVideo[0].fileUrl} className='border object-fit-cover' style={{ height: '40vh', width: '25vw' }} alt="photoVideo" />
                        }
                      </div>

                      <div className='d-flex flex-column'>
                        <div style={{ height: '20vh' }}>
                          {
                            (postsPopupData.photoVideo[1].fileUrl.includes('mp4'))
                            ?
                            <video src={AwsFileUrl+postsPopupData.photoVideo[1].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                            :
                            <img src={AwsFileUrl+postsPopupData.photoVideo[1].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                          }
                        </div>

                        <div style={{ height: '20vh' }}>
                          {
                            (postsPopupData.photoVideo[2].fileUrl.includes('mp4'))
                            ?
                            <video src={AwsFileUrl+postsPopupData.photoVideo[2].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                            :
                            <img src={AwsFileUrl+postsPopupData.photoVideo[2].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                          }
                        </div>
                      </div>
                    </div>
                  }
                </>

                {/* Camera/Photo/Video > Grid (4 or more) */}
                <>
                  {
                    (postsPopupData.carouselGrid === 'grid' && postsPopupData.photoVideo && postsPopupData.photoVideo.length >= 4)
                    &&
                    <div className='border my-3 bg-light d-flex align-items-center justify-content-center flex-grow-1' style={{ height: '40vh' }} onClick={() => handleClickGridPost(postsPopupData)} >
                      <div className='d-flex flex-column'>
                        <div style={{ height: '20vh' }}>
                          {
                            (postsPopupData.photoVideo[0].fileUrl.includes('mp4'))
                            ?
                            <video src={AwsFileUrl+postsPopupData.photoVideo[0].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                            :
                            <img src={AwsFileUrl+postsPopupData.photoVideo[0].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                          }
                        </div>

                        <div style={{ height: '20vh' }}>
                          {
                            (postsPopupData.photoVideo[1].fileUrl.includes('mp4'))
                            ?
                            <video src={AwsFileUrl+postsPopupData.photoVideo[1].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                            :
                            <img src={AwsFileUrl+postsPopupData.photoVideo[1].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                          }
                        </div>
                      </div>

                      <div className='d-flex flex-column'>
                        <div style={{ height: '20vh' }}>
                          {
                            (postsPopupData.photoVideo[2].fileUrl.includes('mp4'))
                            ?
                            <video src={AwsFileUrl+postsPopupData.photoVideo[2].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                            :
                            <img src={AwsFileUrl+postsPopupData.photoVideo[2].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                          }
                        </div>

                        <div className={`${postsPopupData.photoVideo.length > 4 ? 'position-relative' : ''}`} style={{ height: '20vh' }}>
                          {
                            (postsPopupData.photoVideo[3].fileUrl.includes('mp4'))
                            ?
                            <video src={AwsFileUrl+postsPopupData.photoVideo[3].fileUrl} className='border rounded-0 object-fit-cover' style={{ height: '20vh', width: '25vw' }} ></video>
                            :
                            <img src={AwsFileUrl+postsPopupData.photoVideo[3].fileUrl} className='border object-fit-cover' style={{ height: '20vh', width: '25vw' }} alt="photoVideo" />
                          }

                          <>
                            {
                              (postsPopupData.photoVideo.length > 4)
                              &&
                              <span className='position-absolute top-50 start-50 translate-middle h-100 w-100 d-flex align-items-center justify-content-center text-white' 
                                style={{ fontSize: '30px', backgroundColor: '#80808080' }}
                              >+{postsPopupData.photoVideo.length-4}</span>
                            }
                          </>
                        </div>
                      </div>
                    </div>
                  }
                </>

                {/* Text with background */}
                <>
                  {
                    postsPopupData.postType === 'textWithBackground'
                    &&
                    <div className={`my-3 d-flex align-items-center justify-content-center text-center text-break text-white fs-2 px-3 flex-grow-1`} 
                      style={{ 
                        height: '40vh', 
                        backgroundImage: `url('${postsPopupData.textBackgroundImage}')`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        whiteSpace: 'pre-wrap',
                      }}
                    >{postsPopupData.text}</div>
                  }
                </>

                {/* Text */}
                <>
                  {
                    (postsPopupData.postType === 'text' && postsPopupData.text)
                    &&
                    <div className='my-3 text-break px-2'>
                      {seeMoreLess[postsPopupData._id] ? postsPopupData.text : postsPopupData.text.slice(0, 50) + (postsPopupData.text.length > 50 ? "..." : "")}

                      {
                        postsPopupData.text.length > 50 
                        && 
                        <small className="text-primary cursor-pointer" onClick={() => handleSeeMoreLess(postsPopupData._id)}>
                          {seeMoreLess[postsPopupData._id] ? " See less..." : " See more..."}
                        </small>
                      }
                    </div>
                  }
                </>
              </div>

              {/* Left > Photos And Videos (old) */}
              {/* <section className="profilePostsPopup-post">
                <Slider {...settings} ref={sliderRef}>
                  {
                    postsPopupData.mediaUrls
                    &&
                    postsPopupData.mediaUrls.map((details, index) => (

                      details.filetype === 'image'
                      ?
                      <div key={index} className="profilePostsPopup-post-pav">
                        <ImageTag
                          classHere="profilePostsPopup-post-image"
                          url={details.url}
                          altHere={details.imageId}
                          onError={(e) => e.target.src = `${BASE_URL_STATIC}/cp-3.png`}
                          styleHere={{ width: '100%', height: '100%' }}
                        />
                      </div>
                      :
                      <div key={index} className="profilePostsPopup-post-pav">
                        <VideoTag
                          controls={true}
                          url={details.url}
                          classHere="profilePostsPopup-post-video"
                          autoPlay={index === activeIndex}
                          mute={false}
                        />
                      </div>
                    ))
                  }
                </Slider>
              </section> */}

              {/* Right > Details */}
              <div className="w-50">
                {/* profile, name, feeling, activity, check in/location, posted time */}
                <div className='d-flex align-items-center px-2 gap-1'>
                  {/* Profile */}
                  <div>
                    <img src={AwsFileUrl+postsPopupData.profile} className='rounded-circle' style={{ height: '40px', width: '40px' }} alt="profile" />
                  </div>

                  {/* name, feeling, activity, check in/location, posted time */}
                  <div className='mx-3 me-auto'>
                    {/* Name */}
                    <span className='fs-5 mb-0 me-2 d-inline'>{postsPopupData.name}</span>

                    {/* Feeling */}
                    <>
                      {
                        (postsPopupData.feeling && postsPopupData.feeling._id !== '')
                        &&
                        (
                          <span className='me-2 d-inline'>
                            <span className='text-secondary'>is</span> feeling {postsPopupData.feeling.feelingName} {" "}
                            <img src={postsPopupData.feeling.feelingIcon} style={{ height: '17px', width: '17px' }} alt="icon" />
                          </span>
                        )
                      }
                    </>

                    {/* Activity */}
                    <>
                      {
                        (postsPopupData.activityCategory && postsPopupData.activityCategory._id !== '' && postsPopupData.activity && postsPopupData.activity._id !== '')
                        &&
                        (
                          <span className='me-2 d-inline'>
                            <span className='text-secondary'>is</span> {postsPopupData.activityCategory.activityCategoryName} {" "}
                            <img src={postsPopupData.activityCategory.activityCategoryIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {" "}
                            {postsPopupData.activity.activityName} {" "}
                            <img src={postsPopupData.activity.activityIcon} style={{ height: '17px', width: '17px' }} alt="icon" />
                          </span>
                        )
                      }
                    </>

                    {/* Check in/Location */}
                    <>
                      {
                        (postsPopupData.location && postsPopupData.location.place !== '' && postsPopupData.location.lat !== '' && postsPopupData.location.lng !== '')
                        &&
                        <>
                          <span className='text-secondary d-inline'>at</span> {' '}
                          {postsPopupData.location.place}
                          {/* {postsPopupData.location.place && postsPopupData.location.place.split(" ").slice(0, 5).join(" ")} */}
                          {/* {postsPopupData.location.place && postsPopupData.location.place.split(" ").length > 5 && "..."} */}
                        </>
                      }
                    </>

                    {/* show posted time */}
                    <div>{postsPopupData.postedAt}</div>
                  </div>

                  {/* Follow/Unfollow Button */}
                  <>
                    {
                      (postsPopupData.buttonText !== '')
                      &&
                      <button type="button" className='btn btn-primary btn-sm text-nowrap' onClick={() => handleFollowUnfollow(postsPopupData.userId)}>{postsPopupData.buttonText}</button>
                    }
                  </>

                  {/* Three dot popup */}
                  <img src={`${Image_Base_Url}/icons/three-dot-black.svg`} className='cursor-pointer' style={{ height: '20px', width: '20px' }} alt="threeDot" 
                    onClick={() => handleClickThreeDot(postsPopupData)}
                  />
                </div>

                {/* User (old code) */}
                {/* <div className='profilePostsPopup-details-user mx-3'>
                  <img src={AwsFileUrl+postsPopupData.profile} className='object-fit-conver rounded-circle' style={{ height: '40px', width: '40px' }} alt="profile" />

                  <div className='profilePostsPopup-details-header'>
                    <div className='profilePostsPopup-details-head'>
                      <span className='profilePostsPopup-details-name'>{postsPopupData.name}</span>
                      <span className='text-secondary fs-14'>username123@</span>
                    </div>

                    {
                      postsPopupData.title
                      &&
                      <span className='profilePostsPopup-details-location'>{postsPopupData.title}</span>
                    }
                  </div>

                  <img className='profilePostsPopup-details-threeDot' src={`${BASE_URL_STATIC}/icon/threeDot.svg`} alt="three dot"  onClick={() =>handleThreeDotsClick( postsPopupData) }/>
                </div> */}

                <hr className="profilePostsPopup-details-hr" />

                {/* Comments */}
                <AddComments 
                  showProfilePostThreeDotPopup={showProfilePostThreeDotPopup} showProfilePostCommentThreeDotPopup={showProfilePostCommentThreeDotPopup} 
                  setShowProfilePostCommentThreeDotPopup={setShowProfilePostCommentThreeDotPopup} 
                  setComment={setComment} commentType={"post"} clickedreply={clickedreply} setClickedReply={setClickedReply} postId={postId} viewReply={viewReply} 
                  postsPopupData={postsPopupData} comments={comments} setComments={setComments} parentSpinner={parentSpinner} setParentSpinner={setParentSpinner} 
                  setPostsPopupData={setPostsPopupData} 
                />

                <hr className="hr" />

                {/* Music Text (eg : - icon - name - play - close ) */}
                <>
                  {
                    (postsPopupData.music && postsPopupData.music._id && postsPopupData.music._id !== '')
                    &&
                    <div className='d-flex align-items-center gap-3 my-3 px-2'>
                      <img src='/images/icons/music.svg' style={{ height: '17px', width: '17px' }} alt='music' />

                      <span className='me-auto text-truncate'>{postsPopupData.music.name}</span>

                      <img src={`/images/icons/unmute.svg`} className="cursor-pointer" style={{ height: "25px" }} alt="muteUnmute" />
                    </div>
                  }
                </>

                <hr className="hr" />

                {/* View, Like, Comment, Share, Favourite, Download */}
                <div className='d-flex align-items-center gap-2 gap-sm-3 gap-md-4 gap-lg-5 my-3 px-2'>
                  {/* View */}
                  <div className='d-flex align-items-center gap-1'>
                    <img src={`${BASE_URL_STATIC}/icon/view-${postsPopupData.viewed ? '2' : '1'}.svg`} style={{ height: '23px', width: '23px' }} alt="view" />
                    <span className='cursor-pointer' 
                      // onClick={() => handleClickPostView(postsPopupData._id)}
                    >{postsPopupData.viewCount}</span>
                  </div>

                  {/* Like */}
                  <div className='d-flex align-items-center gap-1'>
                    <img src={`${BASE_URL_STATIC}/icon/like-${postsPopupData.liked ? '2' : '1'}.svg`} className='cursor-pointer' style={{ height: '23px', width: '23px' }} alt="view" 
                      // onClick={() => handlePostLikeDislike(postsPopupData._id)}
                    />

                    <>
                      {
                        (!postsPopupData.hidelikeCount)
                        &&
                        <span className='cursor-pointer' 
                          // onClick={() => handleClickPostLike(postsPopupData._id)}
                        >{postsPopupData.likeCount}</span>
                      }
                    </>
                  </div>

                  {/* Comment */}
                  <div className='d-flex align-items-center gap-1 cursor-pointer' 
                    // onClick={() => handleClickComment(postsPopupData)}
                  >
                    <img src={`${BASE_URL_STATIC}/icon/comment-1.svg`} style={{ height: '23px', width: '23px' }} alt="view" />
                    <span>0</span>
                  </div>

                  {/* Share */}
                  <div className='d-flex align-items-center gap-1 flex-grow-1 cursor-pointer'>
                    <img src={`${BASE_URL_STATIC}/icon/share-1.svg`} style={{ height: '23px', width: '23px' }} alt="view" />
                    <span>0</span>
                  </div>

                  {/* Favourite */}
                  <img src={`${BASE_URL_STATIC}/icon/favourite-${postsPopupData.favourite ? '2' : '1'}.svg`}  alt="view"
                    className='cursor-pointer' style={{ height: '23px', width: '23px' }} 
                    // onClick={() => handleClickPostFavourite(postsPopupData._id)}  
                  />

                  {/* Download */}
                  <img src={`${BASE_URL_STATIC}/icon/download-1.svg`} style={{ height: '23px', width: '23px' }} alt="view" />
                </div>

                {/* Area (old) */}
                {/* <div className='profilePostsPopup-details-area'>
                  <div className='flex'>
                    <div className='profilePostsPopup-details-area-div'>

                    {postsPopupData && postsPopupData._id && (
                      <ViewPostButton viewCount={postsPopupData.viewCount} postId={postsPopupData._id} />
                    )}
                    </div>

                    <div className='profilePostsPopup-details-area-div'>
                    {postsPopupData && postsPopupData._id && (
                   <LikeButton postId={postsPopupData._id} likecounts={postsPopupData.likecount} postType={postsPopupData.type} />
  
                    )}
                    </div>

                    <div className='profilePostsPopup-details-area-div'>
                      <img className='profilePostsPopup-details-area-icon' src={`${BASE_URL_STATIC}/icon/comment-1.svg`} alt="comment" />
                      <span className='profilePostsPopup-details-area-count'>{postsPopupData.commentcount}</span>
                    </div>

                    <div className='profilePostsPopup-details-area-div'>
                      <img onClick={handlePostShare} className='profilePostsPopup-details-area-icon' src={`${BASE_URL_STATIC}/icon/share-1.svg`} alt="share" />
                      <span className='profilePostsPopup-details-area-count'>{postsPopupData.sharecount}</span>
                    </div>
                  </div>

                  <div className='flex'>
                    <div className='profilePostsPopup-details-area-favourite'>
                      <FavouritePostButton postId={postsPopupData.postId} />
                    </div>

                    <img className='profilePostsPopup-details-area-download' src={`${BASE_URL_STATIC}/icon/download-1.svg`} alt="download" />
                  </div>
                </div> */}

                {/* Description */}
                {postsPopupData && postsPopupData.details && postsPopupData.details.length > 0 && <div className='profilePostsPopup-details-description'>{postsPopupData.description}</div>}
              </div>
            </section>
          }
        </Modal.Body>
      </Modal>
    </>
  )
}

export default ProfilePostPopup;
